import {
	useRemoveNavbarItemIcon,
	useSetNavbarItemIcon,
} from "@src/components/board/mutations/set-navbar-item-icon";
import { IconType, type NavbarSection } from "@src/gql/graphql";
import { useCallback, useState } from "react";

export function useNavTreeItemIcon({
	section,
	itemKey,
	icon,
}: {
	section: NavbarSection;
	itemKey: string;
	icon?: string | null;
}) {
	const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
	const { mutateAsync: setNavbarItemIcon } = useSetNavbarItemIcon();
	const { mutateAsync: removeNavbarItemIcon } = useRemoveNavbarItemIcon();

	const emoji = icon ?? null;

	const openEmojiPicker = useCallback(() => {
		setIsEmojiPickerOpen(true);
	}, []);

	const closeEmojiPicker = useCallback(() => {
		setIsEmojiPickerOpen(false);
	}, []);

	const handleSetEmoji = useCallback(
		(newEmoji: string) => {
			void setNavbarItemIcon({
				section,
				itemKey,
				icon: { type: IconType.Emoji, value: newEmoji },
			});
		},
		[itemKey, section, setNavbarItemIcon],
	);

	const handleRemoveEmoji = useCallback(() => {
		void removeNavbarItemIcon({
			section,
			itemKey,
		});
	}, [itemKey, removeNavbarItemIcon, section]);

	return {
		emoji,
		isEmojiPickerOpen,
		openEmojiPicker,
		closeEmojiPicker,
		handleSetEmoji,
		handleRemoveEmoji,
	};
}
